import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	ClosedMemberDuplicationCheckDTO,
	FileNoHistoryDTO,
	LinkClosedMemberRequest,
	LinkLegacyFileNoRequest,
	MemberDuplicationCheckDTO,
	MemberDuplicationCheckRequest,
} from '../DTO/member-management/memberDuplication';
import { FamilyMemberDuplicationCheckDTO } from '../DTO/family/family.interface';

export const memberDuplication = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		checkMemberDuplication: builder.mutation<
			SuccessResponse<MemberDuplicationCheckDTO[]>,
			MemberDuplicationCheckRequest
		>({
			query: (body) => ({
				url: `/web/member/check-duplication`,
				method: 'POST',
				body,
			}),
		}),
		// CHA-005 §2.2: unlinked admitted family members of this centre, before New register / Re-register.
		checkMemberFamilyMemberDuplication: builder.mutation<
			SuccessResponse<FamilyMemberDuplicationCheckDTO[]>,
			MemberDuplicationCheckRequest
		>({
			query: (body) => ({
				url: `/web/member/check-family-member-duplication`,
				method: 'POST',
				body,
			}),
		}),
		checkClosedMemberDuplication: builder.mutation<
			SuccessResponse<ClosedMemberDuplicationCheckDTO[]>,
			MemberDuplicationCheckRequest
		>({
			query: (body) => ({
				url: `/web/member/check-closed-duplication`,
				method: 'POST',
				body,
			}),
		}),
		linkClosedMember: builder.mutation<
			SuccessResponse<null>,
			LinkClosedMemberRequest
		>({
			query: ({ userId, closedUserId }) => ({
				url: `/web/member/${userId}/link-closed-member`,
				method: 'PUT',
				body: { closedUserId },
			}),
			invalidatesTags: ['AdmissionRequestDetail', 'PreAdmissionDetail'],
		}),
		linkLegacyFileNo: builder.mutation<
			SuccessResponse<null>,
			LinkLegacyFileNoRequest
		>({
			query: ({ userId, legacyFileNo }) => ({
				url: `/web/member/${userId}/link-legacy-file-no`,
				method: 'PUT',
				body: { legacyFileNo },
			}),
			invalidatesTags: ['AdmissionRequestDetail', 'PreAdmissionDetail'],
		}),
		/** Admission Request stage before admission only (status 0, 2, 4, 6). */
		unlinkClosedMember: builder.mutation<SuccessResponse<null>, string>({
			query: (userId) => ({
				url: `/web/member/${userId}/link-closed-member`,
				method: 'DELETE',
			}),
			invalidatesTags: ['AdmissionRequestDetail'],
		}),
		getFileNoHistory: builder.query<
			SuccessResponse<FileNoHistoryDTO[]>,
			string
		>({
			query: (userId) => ({
				url: `/web/member/${userId}/file-no-history`,
			}),
		}),
	}),
});

export const {
	useCheckMemberDuplicationMutation,
	useCheckMemberFamilyMemberDuplicationMutation,
	useCheckClosedMemberDuplicationMutation,
	useLinkClosedMemberMutation,
	useLinkLegacyFileNoMutation,
	useUnlinkClosedMemberMutation,
	useGetFileNoHistoryQuery,
} = memberDuplication;
